import React from "react";
import { Empty, Button } from "antd";
import { DeleteOutlined, UsergroupAddOutlined } from "@ant-design/icons";
import type { SelectedPanelProps } from "./types";
import SelectedMemberCard from "./SelectedMemberCard";
import { EMPTY_TEXTS } from "./utils/constants";
import styles from "./SelectedPanel.module.css";

const SelectedPanel: React.FC<SelectedPanelProps> = ({
  members,
  showClearAction,
  onRemove,
  onClearAll,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div>
          <div className={styles.headerTitleRow}>
            <UsergroupAddOutlined />
            <span className={styles.headerTitle}>已選成員</span>
          </div>
          <div className={styles.headerHint}>目前已選擇 {members.length} 人</div>
        </div>

        {showClearAction && members.length > 0 ? (
          <Button
            type="text"
            icon={<DeleteOutlined />}
            onClick={onClearAll}
            className={styles.clearButton}
          >
            清空
          </Button>
        ) : null}
      </div>

      <div className={styles.content}>
        {members.length === 0 ? (
          <div className={styles.emptyState}>
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <div className={styles.emptyText}>
                  <div>{EMPTY_TEXTS.NO_SELECTED}</div>
                  <div className={styles.emptySubText}>
                    {EMPTY_TEXTS.SELECT_FROM_LEFT}
                  </div>
                </div>
              }
            />
          </div>
        ) : (
          <div className={styles.list}>
            {members.map((member) => (
              <SelectedMemberCard
                key={member.uid}
                member={member}
                onRemove={onRemove}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectedPanel;
